import { render, staticRenderFns } from "./ProductAddBulk.vue?vue&type=template&id=77665db3&"
import script from "./ProductAddBulk.vue?vue&type=script&lang=ts&"
export * from "./ProductAddBulk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports